<template>
	<div id="top">
		<div style="height: 48px;line-height: 48px;" class="middle-row center">
			<span style="padding: 10px 0px;font-size: 24px;">商户列表</span>
		</div>
		<div class="middle-row around" style="width: 100%;">
			<div class="subinput middle-row around">
				<div class="input-group">
					<span class="input-group-addon">所属街道</span>
					<select name="" id="select" v-model="street" class="form-control">
						<option value="">全部街道</option>
						<option value="东山街道">东山街道</option>
						<option value="南黎街道">南黎街道</option>
						<option value="曲阳街道">曲阳街道</option>
						<option value="渠沟镇">渠沟镇</option>
						<option value="任圩街道">任圩街道</option>
						<option value="三堤口">三堤口</option>
						<option value="相南街道">相南街道</option>
						<option value="相山东街道">相山东街道</option>
						<option value="相山西街道">相山西街道</option>
						<option value="凤凰山经济开发区">凤凰山经济开发区</option>
					</select>
				</div>
			</div>
			<div class="subinput middle-row around">
				<div class="input-group">
					<span class="input-group-addon">商户名称</span>
					<input type="text" v-model="merchantName" class="form-control" placeholder="商户名称">
				</div>
			</div>
			<div class="subinput middle-row around">
				<div class="input-group">
					<span class="input-group-addon">商户联系人</span>
					<input type="text" v-model="owner" class="form-control" placeholder="商户联系人">
				</div>
			</div>
			<div class="subinput middle-row around">
				<div class="input-group">
					<span class="input-group-addon">联系电话</span>
					<input type="text" v-model="phone" class="form-control" placeholder="联系电话">
				</div>
			</div>
			<div class="subinput middle-row around">
				<div class="input-group">
					<button type="button" class="btn btn-success" @click="search">搜索</button>
				</div>
			</div>
		</div>
		<div style="background-color:#FFFFFF;">
			<table style="width: 100%;padding: 10px;margin-bottom: 0px;table-layout:fixed;"
				class="table table-condensed">
				<thead>
					<tr>
						<th v-for="(th, i) in tableList" :key="i">{{ th }}</th>
					</tr>
				</thead>
				<tbody>
					<tr style="height: 30px !important; line-height: 30px; border-bottom: 1px solid #ccc; "
						v-for="(mer, i) in merchants" :key="i">
						<td>{{ mer.merchantName }}</td>
						<td>{{ mer.street }}</td>
						<td>{{ mer.owner }}</td>
						<td>{{ mer.phone }}</td>
						<td>{{ mer.location }}</td>
						<td>{{ mer.lastTime }}</td>
						<td>{{ mer.scale }}</td>
						<td>{{ mer.clearType == 0 ? '自行清洗' : '清洗公司清洗' }}</td>
						<td>{{ mer.status == 0 ? '待审核' : (mer.status == 1 ? '审核通过' : '审核未通过') }}</td>
						<td>{{ mer.examination }}</td>
					</tr>
				</tbody>
			</table>
			<div class="middle-row center" style="height:77px;width: 100%;background-color: #EFEFEF;">
				<ul class="pagination pagination" v-if="pagetotal <= 5">
					<li><a href="#" @click="tofirst">首页</a></li>
					<li><a href="#" @click="laquo">&laquo;</a></li>
					<li v-for="n in pagetotal" :key="n"><a href="#" @click="pageClick(n)">{{ n }}</a></li>
					<li><a href="#" @click="raquo">&raquo;</a></li>
					<li><a href="#" @click="tolast">尾页</a></li>
				</ul>
				<ul class="pagination pagination" v-if="pagetotal >= 6">
					<li><a href="#" @click="tofirst">首页</a></li>
					<li><a href="#" @click="laquo">&laquo;</a></li>
					<li><a href="#" @click="pageClick(1)">1</a></li>
					<li><a href="#" @click="pageClick(2)">2</a></li>
					<li><a href="#">...</a></li>
					<li><a href="#" @click="pageClick(pagetotal - 1)">{{ pagetotal - 1 }}</a></li>
					<li><a href="#" @click="pageClick(pagetotal)">{{ pagetotal }}</a></li>
					<li><a href="#" @click="raquo">&raquo;</a></li>
					<li><a href="#" @click="tolast">尾页</a></li>
				</ul>
				<span style="margin-left: 10px;">共<b>{{ merchantTotal }}</b>条数据，共<b>{{ pagetotal }}</b>页，当前第<b>{{
					pageindex + 1 }}</b>页，转跳至第<input type="text" v-model="topage" @keydown.enter="skipto"
						style="margin: 5px;text-align: center;" size="1" /> 页</span>&nbsp;&nbsp;&nbsp;
				<button class="btn btn-primary" @click="toExcel">导出excel</button>
			</div>
		</div>
	</div>
</template>

<script>
import { util } from "../../static/util.js"
export default ({
	data() {
		return {
			merchants: [],
			pageindex: 0,
			pagetotal: 0,
			tableList: ['商户名称', '所属街道', '商户联系人', '联系电话', '详细地址', '最近一次清洗时间', '餐饮规模', '清洗方式', '审核状态', '审核描述'],
			merchantTotal: 0,
			topage: 1,
			merchantName: '',
			street: '',
			owner: '',
			phone: ''
		}
	},
	methods: {
		toExcel: function () {
			this.$http.get(this.GLOBAL.base + "getMerchantPageableAll").then(function (msg) {
				var mers = msg.body;
				for (let mer of mers) {
					mer.lastTime = util.timeToStringWithYear(mer.lastTime);
					if (mer.status == 0) {
						mer.status = '待审核';
					} else if (mer.status == 1) {
						mer.status = '审核通过';
					} else if (mer.status == 2) {
						mer.status = '审核未通过';
					}
					if (mer.clearType == 0) {
						mer.clearType = '自行清洗';
					} else if (mer.clearType == 1) {
						mer.clearType = '清洗公司清洗';
					}
				}
				var option = {};
				option.fileName = '商户列表';
				option.datas = [{
					sheetData: mers,
					sheetName: '商户列表',
					sheetHeader: this.tableList,
					sheetFilter: ['merchantName', 'street', 'owner', 'phone', 'location', 'lastTime', 'scale', 'clearType', 'status', 'examination'],
				}];
				var toExcel = new ExportJsonExcel(option);
				toExcel.saveExcel();
			})
		},
		setPage: function () {
			var i = this.merchantTotal / 16;
			if (i % 1 == 0) {
				this.pagetotal = i;
			} else {
				this.pagetotal = Math.ceil(i);
			}
		},
		pageClick: function (n) {
			this.topage = n;
			this.skipto();
		},
		skipto: function () { //跳转至指定页面
			var numReg = /^[0-9]*$/
			var numRe = new RegExp(numReg)
			if (!numRe.test(this.topage)) {
				alert('请输入正确的数字');
				return;
			}
			if (this.topage < 0 || this.topage > this.pagetotal) {
				alert("请输入正确的页码范围");
				return;
			}
			if (this.topage == this.pageindex + 1) {
				return;
			}
			this.pageindex = this.topage - 1;
			this.pageable();
		},
		laquo: function () {
			if (this.pageindex == 0) {
				return
			} else {
				this.pageindex--;
				this.pageable();
			}
		},
		raquo: function () {
			if (this.pageindex > this.pagetotal - 1) {
				return
			} else {
				this.pageindex++;
				this.pageable();
			}
		},
		pageable: function () {
			this.$http.get(this.GLOBAL.base + 'getMerchantPageable', {
				params: {
					pageIndex: this.pageindex,
					merchantName: this.merchantName,
					street: this.street,
					owner: this.owner,
					phone: this.phone, inregist: 1
				}
			}).then(function (msg) {
				this.merchants = msg.body;
				for (let mer of this.merchants) {
					mer.lastTime = util.timeToStringWithYear(mer.lastTime)
				}
				this.merchantTotal = this.merchants[0].longitude;
				this.pagetotal = Math.ceil(this.merchantTotal / 16);
				this.setPage();
			})
		},
		search: function () {
			this.pageindex = 0;
			this.pageable();
		},
		tofirst: function () {
			if (this.pageindex == 0) {
				return;
			}
			this.pageindex = 0;
			this.pageable();
		},
		tolast: function () {
			if (this.pageindex == this.pagetotal) {
				return;
			}
			this.pageindex = this.pagetotal - 1;
			this.pageable();
		},
	},
	mounted() {
		this.pageable();
	}
})
</script>

<style></style>
